export type { CustomButtonProps, BaseCustomButtonProps } from './CustomButton.types'
export { default as CustomButton } from './CustomButton'